import React, { useEffect, useState } from "react";
import * as classes from "./flowStepBusinessDetails.module.scss";
import { useForm } from "react-hook-form";
import TextInput from "@components/ui/textInput";
import SubmitButton from "@components/ui/submitButton";
import FlowStepContainer from "./flowStepContainer";

export default function FlowStepBusinessDetails({ stepNo, totalSteps, onDataSubmit, forTrial, defaultValues = {} }) {
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const {
    register,
    handleSubmit,
    setFocus,
    formState: { errors, isValid },
  } = useForm({
    mode: "onSubmit",
    defaultValues,
  });

  const onSubmit = (e) => {
    setHasSubmitted(true);
    onDataSubmit(e);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setFocus("business-name");
    }, 500);
    return () => clearTimeout(timeout);
  }, [setFocus]);

  return (
    <FlowStepContainer
      stepNo={stepNo}
      totalSteps={totalSteps}
      title="What's the name of your business?"
      subTitle={forTrial ? "We'll start adding your business details to your account" : null}
      innerCtnClass={classes.inner}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <TextInput
          tabIndex={1}
          type="text"
          required="required"
          placeholder="Enter the name of your business"
          label="Business Name"
          errors={hasSubmitted ? errors : {}}
          {...register("business-name", {
            required: "Please fill in the name of your business",
            minLength: {
              value: 4,
              message: "Business name must be at least 4 characters long",
            },
          })}
          v2={true}
        />

        <TextInput
          tabIndex={2}
          type="text"
          {...register("website", {
            required: "Please enter your website or let us know if you don't have one",
          })}
          placeholder="Enter your website"
          label="Website"
          errors={hasSubmitted ? errors : {}}
          v2={true}
        />

        <SubmitButton tabIndex={3} className={classes.btn} id={"business-details-submit"} disabled={!isValid}>
          Continue
        </SubmitButton>
      </form>
    </FlowStepContainer>
  );
}
